/**
 * @package entity
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class SerialNumber
 */
export class SerialNumber {
  private counter!: string;

  private device!: string;

  public getCounter(): string {
    return this.counter;
  }

  public getDevice(): string {
    return this.device;
  }

  public changeCounter(counter: string): void {
    this.counter = counter;
  }

  public changeDevice(device: string): void {
    this.device = device;
  }
}
